const styleOverrides = {
  input: {
    '&&:-webkit-autofill': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    }
  }
};
export default {
  styleOverrides
};